# Mustache style templating
_.templateSettings =
  evaluate : /\{\[([\s\S]+?)\]\}/g      # {[ print('hello'); ]}
  interpolate : /\{\{([\s\S]+?)\}\}/g   # {{title}}
  escape: /\{\!([\s\S]+?)\!\}/g         # {!title!}
  
# Add helper to underscore
_.tmpl = (sel) -> _.template($(sel).html())

